export type ViewMode = 'grid' | 'list' | 'image';

const VALID_VIEW_MODES: readonly ViewMode[] = ['grid', 'list', 'image'] as const;

export const VIEW_MODE_STORAGE_KEY = 'legacy-catalog-view-mode';

/**
 * Load view mode from localStorage with validation.
 * Returns 'grid' if stored value is missing or invalid.
 */
export const loadViewMode = (): ViewMode => {
  try {
    const stored = localStorage.getItem(VIEW_MODE_STORAGE_KEY);
    if (stored && VALID_VIEW_MODES.includes(stored as ViewMode)) {
      return stored as ViewMode;
    }
    return 'grid';
  } catch {
    return 'grid';
  }
};

/**
 * Save view mode to localStorage.
 * Silently fails if localStorage is unavailable.
 */
export const saveViewMode = (mode: ViewMode): void => {
  try {
    localStorage.setItem(VIEW_MODE_STORAGE_KEY, mode);
  } catch {
    // localStorage unavailable or full
  }
};
